import { render } from "./SalePriceActions.vue?vue&type=template&id=169a9ea2&scoped=true&ts=true"
import script from "./SalePriceActions.vue?vue&type=script&lang=ts"
export * from "./SalePriceActions.vue?vue&type=script&lang=ts"

import "./SalePriceActions.vue?vue&type=style&index=0&id=169a9ea2&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-169a9ea2"]])

export default __exports__